<template>
    <div event>
        <div class="top-cont">
            <div class="top-btns">
                <a @click="back" class="back">뒤로가기 </a>
                <h2>이벤트</h2>
            </div>
        </div>

        <section style="overflow-y: scroll;">
            <div class="content-detail">
                <ul>
                    <li v-for="(item, i) in list" :key="i" @click="showNotificationDetail(item.idx); $Util.sendEventClick('마이_이벤트_이벤트게시물')">
                        <span>이벤트</span>
                        <p class="tit">{{ item.title }}</p>
                        <p class="txt" style="overflow:hidden;text-overflow: ellipsis; white-space: nowrap;">{{ item.contents }}</p>
                    </li>
                </ul>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: "Event",
    data() {
        return {
            list: []
        }
    },
    methods: {
        back() {
            this.$GlobalStore.closeLastModal()
        },
        async getNotification() {
            const parameters = {};
            parameters.page = this.page;
            parameters.notice_type = '이벤트';
            const res = await this.$Axios.get('/api/notice', { params: parameters });
            const list = res.data.noticeList;

            if (list.length > 0) {
                this.list = [...this.list, ...list];
                this.isEnableNextPageHandle = true;
            }
        },
        handleNextPage() {
            this.page++;
            this.getNotification();
        },
        refresh() {
            this.isEnableNextPageHandle = true;
            this.list = [];
            this.page = 1;
            this.getNotification();
        },
        showNotificationDetail(idx) {
            this.$GlobalStore.addModal('NotificationDetail', { idx: idx, transitionName: 'bottom', title: '이벤트' });
        }
    },
    created() {
        this.getNotification();
    }
}
</script>

<style scoped>
* {
    font-family: var(--global-font-family);
    color: #101014;
}

h2,
h3,
h4,
p,
ul {
    margin: 0;
    padding: 0;
    list-style: none;
    margin-block: 0;
    margin-inline: 0;
}

a {
    display: inline-block;
    text-decoration: none;
    color: #101014;
}

h2 {
    font-size: 24px;
    font-weight: 500;
    line-height: 35px;
    padding: 18px 20px 10px 20px;
    box-sizing: border-box;
}

h3 {
    font-size: 20px;
    line-height: 29px;
    font-weight: 500;
    display: inline-block;
}

input {
    outline: none;
}

input[type=number]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

[event] {
    overflow: hidden;
}

.top-cont {
    width: 100%;
    background: #fff;
    z-index: 1;
}

section {
    position: relative;
}

.top-btns {
    height: 60px;
    border-bottom: 1px solid;
    border-color: #F5F5F5;
    padding-top: 7px;
    box-sizing: border-box;
    text-align: center;
}

.top-btns h2 {
    padding: 0;
    display: inline-block;
    border-bottom: none;
    line-height: 53px;
}

.top-btns a.back {
    font-size: 0;
    width: 65px;
    height: 53px;
    position: absolute;
    left: 0;
    top: 7px;
}

.top-btns a.back:after {
    content: '';
    width: 25px;
    height: 29px;
    background: url("~@/assets/images/mypage/ico-back.png")0 0 no-repeat;
    background-size: contain;
    position: absolute;
    left: 20px;
    top: 12px;
}

ul li {
    border-bottom: 1px solid #F6F6F6;
    padding: 20px;
    box-sizing: border-box;
}

ul li span {
    font-size: 14px;
    color: #808080;
    margin-bottom: 3px;
    display: block;
}

ul li p {
    font-size: 16px;
    line-height: 23px;
    font-weight: 500;
}

ul li p.txt {
    font-weight: 400;
    color: #606060;
}
</style>